import { requestBaseService } from './index'

const getProgram = () => {
  return requestBaseService({
    url: 'member/ex/v1/program',
    method: 'GET',
  })
}

const getProgramDetail = (payload) => {
  return requestBaseService({
    url: `member/ex/v1/program/${payload}`,
    method: 'GET',
  })
}

const updatePopupDisclaimerStatus = () => {
  return requestBaseService({
    url: 'member/ex/v1/members/popup-disclaimer',
    method: 'PUT',
    data: {
      platform: 'web',
      is_popup: true,
    },
  })
}

const Member = {
  getProgram,
  getProgramDetail,
  updatePopupDisclaimerStatus,
}

export default Member
